import cs from "vuetify/es5/locale/cs"

export default {
  ...cs,

  dataTable: {
    itemsPerPageText: "Počet řádků na stránku:",
    ariaLabel: {
      sortDescending: "Řazeno sestupně.",
      sortAscending: "Řazeno vzestupně.",
      sortNone: "Neseřazeno.",
      activateNone: "Aktivováním vypnete řazení.",
      activateDescending: "Aktivováním se bude řadit sestupně.",
      activateAscending: "Aktivováním se bude řadit vzestupně.",
    },
    sortBy: "Řadit dle",
  },
}
